import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  RequirementActionResponse, RequirementApiResponse, RequirementListRequest,
  RequirementPageResponse, RequirementRecordResponse, RequirementRequest,
  RequirementStatusesResponse, RequirementSummaryRequest, RequirementSummaryResponse,
  RequirementViewResponse,
} from "../model/requirement.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffRequirementsService {
  private readonly requirementsUrl: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.requirementsUrl = `${basePath.replace(/\/$/, "")}/api/v1/requirements`;
  }

  list(request: RequirementListRequest): Observable<RequirementApiResponse<RequirementPageResponse>> {
    return this.http.get<RequirementApiResponse<RequirementPageResponse>>(this.requirementsUrl, {
      params: Object.fromEntries(Object.entries(request).filter(([, value]) => value !== undefined && value !== null && value !== "")),
    });
  }

  listMine(request: Omit<RequirementListRequest, "requesterUserId"> = {}): Observable<RequirementApiResponse<RequirementPageResponse>> {
    return this.http.get<RequirementApiResponse<RequirementPageResponse>>(`${this.requirementsUrl}/mine`, {
      params: Object.fromEntries(Object.entries(request).filter(([, value]) => value !== undefined && value !== null && value !== "")),
    });
  }

  get(id: number): Observable<RequirementApiResponse<RequirementViewResponse>> {
    return this.http.get<RequirementApiResponse<RequirementViewResponse>>(`${this.requirementsUrl}/${id}`);
  }

  create(request: RequirementRequest): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(this.requirementsUrl, request);
  }

  update(id: number, request: RequirementRequest): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.put<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}`, request);
  }

  delete(id: number): Observable<RequirementActionResponse> {
    return this.http.delete<RequirementActionResponse>(`${this.requirementsUrl}/${id}`);
  }

  listStatuses(): Observable<RequirementApiResponse<RequirementStatusesResponse>> {
    return this.http.get<RequirementApiResponse<RequirementStatusesResponse>>(`${this.requirementsUrl}/statuses`);
  }

  summary(request: RequirementSummaryRequest = {}): Observable<RequirementApiResponse<RequirementSummaryResponse>> {
    return this.http.get<RequirementApiResponse<RequirementSummaryResponse>>(`${this.requirementsUrl}/summary`, {
      params: Object.fromEntries(Object.entries(request).filter(([, value]) => value !== undefined && value !== null && value !== "")),
    });
  }

  mineSummary(month?: string): Observable<RequirementApiResponse<RequirementSummaryResponse>> {
    return this.http.get<RequirementApiResponse<RequirementSummaryResponse>>(`${this.requirementsUrl}/mine/summary`, {
      params: month ? { month } : {},
    });
  }
}
